import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export interface CustomBreadcrumbItem {
    to: string;
    text: string;
}

const CustomBreadcrumb = (props: { breadcrumbs: CustomBreadcrumbItem[], containerClassName?: string }) => {
    const {
        breadcrumbs,
        containerClassName = '', // default props
    } = props;

    const createBreadcrumbItem = (breadcrumbItem: CustomBreadcrumbItem, lastItem: boolean) => (
        <React.Fragment key={`bc-${breadcrumbItem.text}`}>
            {lastItem ? (
                <Breadcrumb.Item active className='d-none d-sm-inline-block' aria-current='page'>
                    {breadcrumbItem.text}
                </Breadcrumb.Item>
            ) : (
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: breadcrumbItem.to }} className='with-link'>
                    <i className='icon-back d-inline-block d-sm-none me-2' aria-hidden='true' role='presentation' />
                    {breadcrumbItem.text}
                </Breadcrumb.Item>
            )}
        </React.Fragment>
    );

    return (
        <>
            <h2 id='bc-area' className='d-none'>Bread crumb</h2>
            <Breadcrumb role='navigation' className={`py-2 ${containerClassName}`} aria-labelledby='bc-area'>
                {breadcrumbs.map((item, index) => createBreadcrumbItem(item, breadcrumbs.length - 1 === index))}
            </Breadcrumb>
        </>
    );
};

// CustomBreadcrumb.defaultProps = {
//     containerClassName: '',
// };

export default CustomBreadcrumb;
